module.exports = __webpack_public_path__ + "static/media/picto-linkedin.73c1072b.svg";